export default {
  state: {
    authUser: null,
    isAnonymous: false
  },

  setAuthUser(user, persist) {
    persist = persist || false;
    this.state.authUser = user;
    if (persist) {
      localStorage.setItem("auth_user", JSON.stringify(user));
    }
  },

  setIsAnonymous(isAnonymous) {
    this.state.isAnonymous = isAnonymous;
  },

  verifyAuthUser() {
    if (localStorage.getItem("auth_user")) {
      try {
        this.setAuthUser(JSON.parse(localStorage.getItem("auth_user")));
        this.setIsAnonymous(false);
        if (window.EventBus) {
          window.EventBus.$emit("user-logged-in", this.state.authUser);
        }
      } catch (err) {
        this.clearAuthUser();
      }
    }
  },

  clearAuthUser() {
    this.setAuthUser(null);
    localStorage.removeItem("auth_user");
  }
};
